import { useState, useEffect } from 'react';
import { useServices } from '@/app/providers/ServiceContext';
import type { User } from '@/shared/types';

export const useCurrentUser = () => {
  const { userRepo } = useServices();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        const u = await userRepo.getCurrentUser();
        setUser(u);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [userRepo]);

  const updateUser = async (updates: Partial<User>) => {
    if (!user) return;
    const updatedUser = { ...user, ...updates };
    await userRepo.updateUser(updatedUser);
    setUser(updatedUser);
    return updatedUser;
  };

  const refreshUser = async () => {
    const u = await userRepo.getCurrentUser();
    setUser(u);
  };

  return { user, setUser, loading, updateUser, refreshUser };
};
